import { useState } from 'react';
import { Phone, Mail, Search, ChevronDown, Menu, X } from 'lucide-react';

const navItems = [
  { label: 'Home', href: '/', hasDropdown: false },
  { label: 'About', href: '#', hasDropdown: false },
  { label: 'Contact', href: '#', hasDropdown: false },
];

export default function PublicHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="w-full" data-testid="public-header">
      {/* Top Info Bar */}
      <div className="bg-[#015492] text-white text-sm">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-8">
          <span className="font-semibold text-sm tracking-wide">Energy Comparison Tool</span>
          <div className="flex items-center gap-5">
            <a href="tel:1300000000" className="flex items-center gap-1.5 hover:text-white/80 transition-colors">
              <Phone className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Contact Us</span>
            </a>
            <a href="mailto:info@example.com" className="flex items-center gap-1.5 hover:text-white/80 transition-colors">
              <Mail className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">Email</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16">
          {/* Logo / Title */}
          <a href="/" className="flex items-center gap-2" data-testid="public-header-logo">
            <Search className="w-6 h-6 text-[#015492]" />
            <span className="text-xl font-bold text-[#015492]">Power Compare</span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a key={item.label} href={item.href} className="px-4 py-2 text-sm font-medium text-[#015492] hover:text-[#9fc521] transition-colors">
                {item.label}
              </a>
            ))}
            <a href="/login" className="ml-3 px-4 py-1.5 text-xs font-medium text-slate-400 hover:text-[#015492] border border-slate-200 rounded-full transition-colors" data-testid="staff-login-btn">
              Staff Login
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden p-2 hover:bg-slate-100 rounded" data-testid="public-mobile-menu-btn">
            {mobileOpen ? <X className="w-6 h-6 text-[#015492]" /> : <Menu className="w-6 h-6 text-[#015492]" />}
          </button>
        </div>
      </div>

      {/* Gradient Strip */}
      <div className="h-1.5" style={{ background: 'linear-gradient(90deg, #9fc521 0%, #00a0af 50%, #015492 100%)' }} />

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-b shadow-lg" data-testid="public-mobile-menu">
          <nav className="px-4 py-4 space-y-1">
            {navItems.map((item) => (
              <a key={item.label} href={item.href} className="block px-3 py-2 text-sm font-medium text-[#015492]">{item.label}</a>
            ))}
            <div className="pt-3 border-t">
              <a href="/login" className="block px-3 py-2 text-sm text-slate-500 text-center border rounded">Staff Login</a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
